import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import styles from "./RadioButton.module.scss";
export const RadioControl = forwardRef((props, ref) => (_jsxs("span", { className: styles.radioWrapper, children: [_jsx("input", { type: "radio", className: styles.radioInput, ref: ref, ...props }), _jsx("span", { className: styles.radioControl })] })));
//# sourceMappingURL=RadioControl.js.map